import request from "../utils/request";

export function sendTranscript(conversationId, email) {
    return request({
        url: `/conversations/${conversationId}/sendTranscript?email=${email}`,
        method: "get",
    });
}



// WEBPACK FOOTER //
// ./src/api/chat.js